//#region COLORS
// Auxiliary function to convert an RGB component to hexadecimal
const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
};
// Auxiliary function for converting an RGB colour to hexadecimal
const rgbToHex = (r: number, g: number, b: number) => {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

// Auxiliary function to convert hexadecimal to RGB colour
const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const generateColorShades = (color1: string, color2: string, numberOfShades: number): string[] => {
  // Convert hexadecimal colours to RGB values
  const rgbColor1 = hexToRgb(color1);
  const rgbColor2 = hexToRgb(color2);

  // Calculate the increment for each RGB component
  if (rgbColor1 && rgbColor2) {
    const stepR = (rgbColor2.r - rgbColor1.r) / (numberOfShades + 1);
    const stepG = (rgbColor2.g - rgbColor1.g) / (numberOfShades + 1);
    const stepB = (rgbColor2.b - rgbColor1.b) / (numberOfShades + 1);

    // Generate intermediate tones
    const shades: string[] = [];
    for (let i = 1; i <= numberOfShades; i++) {
      const r = Math.round(rgbColor1.r + stepR * i);
      const g = Math.round(rgbColor1.g + stepG * i);
      const b = Math.round(rgbColor1.b + stepB * i);
      const hexColor = rgbToHex(r, g, b);
      shades.push(hexColor);
    }

    return shades;
  }
  return [color1, color2];
};

export const generateColorContrast = (color: string): string => {
  const hex = color.slice(1);
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const luminosidad = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  const contraste = luminosidad > 0.5 ? '#000000' : '#ffffff';

  return contraste;
};

export const generateColorsContrast = (numColors: number): [string[], string[]] => {
  const colors: string[] = [];
  const colorsContrast: string[] = [];

  for (let i = 0; i < numColors; i++) {
    const color = '#' + Math.floor(Math.random() * 16777215).toString(16);
    colors.push(color);

    const contraste = generateColorContrast(color);
    colorsContrast.push(contraste);
  }

  return [colors, colorsContrast];
};
//#endregion
